import React, { useState } from 'react';
import { PlusIcon, TrashIcon, InfoIcon, LayoutGridIcon, ListIcon } from 'lucide-react';
export function PivotSelectionStep({
  initialData = [],
  onUpdate
}) {
  const [pivots, setPivots] = useState(initialData.length ? initialData : [{
    name: '',
    length: 400,
    area: 50,
    degrees: 360,
    tradername: 'Western',
    model: 'CP600',
    price: 65000
  }]);
  const [viewMode, setViewMode] = useState('list'); // "list" or "grid"
  const handleAddPivot = () => {
    const newPivot = {
      name: '',
      length: 400,
      area: 50,
      degrees: 360,
      tradername: 'Western',
      model: 'CP600',
      price: 60000
    };
    setPivots([...pivots, newPivot]);
    onUpdate([...pivots, newPivot]);
  };
  const handleRemovePivot = index => {
    const newPivots = pivots.filter((_, i) => i !== index);
    setPivots(newPivots);
    onUpdate(newPivots);
  };
  const handlePivotChange = (index, field, value) => {
    const newPivots = [...pivots];
    newPivots[index] = {
      ...newPivots[index],
      [field]: value
    };
    // Auto calculate area based on length and degrees
    if (field === 'length' || field === 'degrees') {
      const lengthInMeters = parseFloat(newPivots[index].length);
      const degrees = parseFloat(newPivots[index].degrees);
      const areaHa = Math.round(Math.PI * Math.pow(lengthInMeters, 2) * (degrees / 360) / 10000);
      newPivots[index].area = areaHa;
    }
    // Auto adjust price based on model and length
    if (field === 'model' || field === 'length') {
      const basePrice = field === 'model' && value === '8120' ? 70000 : 60000;
      const lengthFactor = newPivots[index].length / 400; // Adjust price based on length
      newPivots[index].price = Math.round(basePrice * lengthFactor);
    }
    setPivots(newPivots);
    onUpdate(newPivots);
  };
  return <div className="space-y-6" data-id="element-4349" data-mp="u68cysgy1e9s">
      <div className="flex justify-between items-center" data-id="element-4350" data-mp="q2txq40tx1xe">
        <div className="text-white text-xl font-medium" data-id="element-4351" data-mp="q4dbnnz0j0w0">
          Select Pivot Machines
        </div>
        <div className="flex bg-slate-800/50 rounded-lg p-1" data-id="element-4352" data-mp="2p95569rv6zx0">
          <button className={`p-2 rounded ${viewMode === 'list' ? 'bg-blue-600 text-white' : 'text-blue-300 hover:text-white'}`} onClick={() => setViewMode('list')} data-id="element-4353" data-mp="2u7gcoduosyc2">
            <ListIcon size={18} data-id="element-4354" data-mp="344ba0tf84sor" />
          </button>
          <button className={`p-2 rounded ${viewMode === 'grid' ? 'bg-blue-600 text-white' : 'text-blue-300 hover:text-white'}`} onClick={() => setViewMode('grid')} data-id="element-4355" data-mp="3465uk6ml2isb">
            <LayoutGridIcon size={18} data-id="element-4356" data-mp="3d4hk05bpraj6" />
          </button>
        </div>
      </div>

      <div className="bg-blue-900/30 rounded-xl p-5 border border-blue-800/30 mb-6" data-id="element-4357" data-mp="3hw9egqxzq0el">
        <div className="flex items-start" data-id="element-4358" data-mp="3mv2q0dtpvhc4">
          <InfoIcon size={20} className="text-blue-400 mr-3 mt-0.5" data-id="element-4359" data-mp="3mu15zjuq3ki9" />
          <div data-id="element-4360" data-mp="3ruf9coldq69y">
            <h3 className="text-white font-medium mb-1" data-id="element-4361" data-mp="3ruylfoocm0g2">
              Pivot Selection Guide
            </h3>
            <p className="text-blue-200 text-sm" data-id="element-4362" data-mp="3vwsepbw7s267">
              Select the pivot machines you want to include in this quote. You
              can add multiple pivots with different specifications. The system
              will automatically calculate coverage area based on length and
              degrees.
            </p>
          </div>
        </div>
      </div>

      {viewMode === 'list' ?
    // List View
    <div className="bg-slate-800/50 rounded-xl border border-blue-800/30" data-id="element-4363" data-mp="169xn4ds3eh79">
          <div className="grid grid-cols-12 gap-4 p-4 border-b border-blue-800/30 text-sm font-medium text-blue-300" data-id="element-4364" data-mp="23wo46ova25q9">
            <div className="col-span-2" data-id="element-4365" data-mp="1yyml43xuq6es">Pivot Name</div>
            <div className="col-span-1 text-center" data-id="element-4366" data-mp="1u6bjmwngqck4">Length (m)</div>
            <div className="col-span-1 text-center" data-id="element-4367" data-mp="1u4i8b41wn45s">Area (ha)</div>
            <div className="col-span-1 text-center" data-id="element-4368" data-mp="1p6p4gho2qm8o">Degrees</div>
            <div className="col-span-2" data-id="element-4369" data-mp="2mmmb31nc9ssb">Tradername</div>
            <div className="col-span-2" data-id="element-4370" data-mp="2mo73akm6kzn0">Model</div>
            <div className="col-span-2 text-right pr-8" data-id="element-4371" data-mp="2hvnsfvevoilw">Price</div>
            <div className="col-span-1" data-id="element-4372" data-mp="2hucl5lm84sq1"></div>
          </div>
          <div className="p-2" data-id="element-4373" data-mp="22dcuymmz8voj">
            {pivots.map((pivot, index) => <div key={index} className="grid grid-cols-12 gap-4 p-2 items-center" data-id="element-4374" data-mp="26g9ag4h80bo9" data-mpi={index}>
                <div className="col-span-2" data-id="element-4375" data-mp="1sfyl55vk7557">
                  <input type="text" value={pivot.name} onChange={e => handlePivotChange(index, 'name', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Pivot name" data-id="element-4376" data-mp="1sh9v5nfll94r" />
                </div>
                <div className="col-span-1" data-id="element-4377" data-mp="2q2xiliu2sh45">
                  <input type="number" value={pivot.length} onChange={e => handlePivotChange(index, 'length', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-center" min="100" max="1000" step="1" data-id="element-4378" data-mp="2bf45q5wdjsp9" />
                </div>
                <div className="col-span-1" data-id="element-4379" data-mp="38v02d320kdim">
                  <input type="number" value={pivot.area} onChange={e => handlePivotChange(index, 'area', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-center" min="1" readOnly data-id="element-4380" data-mp="xf9ch071ar4q" />
                </div>
                <div className="col-span-1" data-id="element-4381" data-mp="125fz4uhzk1kc">
                  <input type="number" value={pivot.degrees} onChange={e => handlePivotChange(index, 'degrees', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-center" min="1" max="360" step="1" data-id="element-4382" data-mp="126rd1n55app6" />
                </div>
                <div className="col-span-2" data-id="element-4383" data-mp="ihytz6vz4kzi">
                  <select value={pivot.tradername} onChange={e => handlePivotChange(index, 'tradername', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '16px'
            }} data-id="element-4384" data-mp="ih77qmo9nzlw">
                    <option value="Western" data-id="element-4385" data-mp="cujy31ebujgq">Western</option>
                    <option value="Pierce" data-id="element-4386" data-mp="cv353n2fvnfz">Pierce</option>
                  </select>
                </div>
                <div className="col-span-2" data-id="element-4387" data-mp="hslgrl7ucgro">
                  <select value={pivot.model} onChange={e => handlePivotChange(index, 'model', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '16px'
            }} data-id="element-4388" data-mp="ml690ib3mlt3">
                    <option value="CP600" data-id="element-4389" data-mp="2zsxhgzox3cms">CP600</option>
                    <option value="8120" data-id="element-4390" data-mp="2v04981u8pm5y">8120</option>
                  </select>
                </div>
                <div className="col-span-2" data-id="element-4391" data-mp="2q0zyv7vkxie1">
                  <div className="relative" data-id="element-4392" data-mp="2q1syzq0199n7">
                    <span className="absolute left-3 top-2 text-gray-400" data-id="element-4393" data-mp="2l2yiwvtg9z6s">
                      $
                    </span>
                    <input type="number" value={pivot.price} onChange={e => handlePivotChange(index, 'price', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg pl-7 pr-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-right" min="0" step="100" data-id="element-4394" data-mp="2gztkp5gekjny" />
                  </div>
                </div>
                <div className="col-span-1 flex justify-center" data-id="element-4395" data-mp="3qxryu0ucqlst">
                  {pivots.length > 1 && <button onClick={() => handleRemovePivot(index)} className="p-1.5 rounded-full bg-red-500/20 text-red-400 hover:bg-red-500/40 hover:text-white transition-colors" data-id="element-4396" data-mp="3r04c40p607zj">
                      <TrashIcon size={16} data-id="element-4397" data-mp="3h6njh00rkyxg" />
                    </button>}
                </div>
              </div>)}
          </div>
          <div className="p-4 border-t border-blue-800/30" data-id="element-4398" data-mp="379snoovvlcmv">
            <button onClick={handleAddPivot} className="w-full py-2.5 rounded-lg border border-dashed border-blue-500/50 bg-blue-900/20 text-blue-400 hover:bg-blue-900/30 hover:text-blue-300 transition-colors flex items-center justify-center" data-id="element-4399" data-mp="37bdhudea2tk7">
              <PlusIcon size={18} className="mr-2" data-id="element-4400" data-mp="337xn5mlrr3a5" />
              Add Another Pivot
            </button>
          </div>
        </div> :
    // Grid View
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4401" data-mp="2jmxdta182flj">
          {pivots.map((pivot, index) => <div key={index} className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30 relative" data-id="element-4402" data-mp="2eom1msngft05" data-mpi={index}>
              {pivots.length > 1 && <button onClick={() => handleRemovePivot(index)} className="absolute top-4 right-4 p-1.5 rounded-full bg-red-500/20 text-red-400 hover:bg-red-500/40 hover:text-white transition-colors" data-id="element-4403" data-mp="2skqwhi62daq8">
                  <TrashIcon size={16} data-id="element-4404" data-mp="32iwys0vs8ivm" />
                </button>}
              <h3 className="text-white font-medium mb-4" data-id="element-4405" data-mp="2xldgmpvyrlye">Pivot {index + 1}</h3>
              <div className="grid grid-cols-1 gap-4 mb-4" data-id="element-4406" data-mp="3ca1bsv1wdtnt">
                <div data-id="element-4407" data-mp="37bzsqa4h1ucc">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4408" data-mp="37bgcqyydtg0y">
                    Pivot Name
                  </label>
                  <input type="text" value={pivot.name} onChange={e => handlePivotChange(index, 'name', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter pivot name" data-id="element-4409" data-mp="3lcj15icun2f1" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-4410" data-mp="iuf5h2d2lqli">
                <div data-id="element-4411" data-mp="dxygk5y1r87d">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4412" data-mp="dv2lcpdl2xmm">
                    Tradername
                  </label>
                  <select value={pivot.tradername} onChange={e => handlePivotChange(index, 'tradername', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '20px'
            }} data-id="element-4413" data-mp="16lkmhkuqyoxe">
                    <option value="Western" data-id="element-4414" data-mp="1wwedxm5rfdlm">Western</option>
                    <option value="Pierce" data-id="element-4415" data-mp="21uo75r7xc44l">Pierce</option>
                  </select>
                </div>
                <div data-id="element-4416" data-mp="26lxsifmfwlao">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4417" data-mp="26n8y8kzg434f">
                    Model
                  </label>
                  <select value={pivot.model} onChange={e => handlePivotChange(index, 'model', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '20px'
            }} data-id="element-4418" data-mp="2bmtw0s2vq5fk">
                    <option value="CP600" data-id="element-4419" data-mp="x4993o3g3925">CP600</option>
                    <option value="8120" data-id="element-4420" data-mp="x1wk4qz9ryfl">8120</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 mb-4" data-id="element-4421" data-mp="164nsghwume30">
                <div data-id="element-4422" data-mp="162unr85sq3xn">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4423" data-mp="162b67sk25hk5">
                    Length (m)
                  </label>
                  <input type="number" value={pivot.length} onChange={e => handlePivotChange(index, 'length', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" min="100" max="1000" step="1" data-id="element-4424" data-mp="1fv0c87wua383" />
                </div>
                <div data-id="element-4425" data-mp="1kuv3wdofuwu7">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4426" data-mp="1kvemzxptrr9t">
                    Area (ha)
                  </label>
                  <input type="number" value={pivot.area} onChange={e => handlePivotChange(index, 'area', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 bg-slate-800/70" min="1" readOnly data-id="element-4427" data-mp="28gypz3vql0ft" />
                  <div className="text-xs text-blue-400 mt-1" data-id="element-4428" data-mp="1krml2g7fzejb">
                    Auto-calculated
                  </div>
                </div>
                <div data-id="element-4429" data-mp="1piw7l7xp21qz">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4430" data-mp="1pje507w3em0h">
                    Degrees
                  </label>
                  <input type="number" value={pivot.degrees} onChange={e => handlePivotChange(index, 'degrees', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" min="1" max="360" step="1" data-id="element-4431" data-mp="1gpsnwhwggsnw" />
                </div>
              </div>
              <div data-id="element-4432" data-mp="2a17hk79tzkur">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-4433" data-mp="2a1plzr6nd5dr">
                  Price
                </label>
                <div className="relative" data-id="element-4434" data-mp="255s59jrh1x0g">
                  <span className="absolute left-4 top-2.5 text-gray-400" data-id="element-4435" data-mp="20bxoao393w52">
                    $
                  </span>
                  <input type="number" value={pivot.price} onChange={e => handlePivotChange(index, 'price', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg pl-8 pr-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" min="0" step="100" data-id="element-4436" data-mp="1vctdjt0ohqcm" />
                </div>
              </div>
            </div>)}
          <button onClick={handleAddPivot} className="h-full min-h-[200px] rounded-xl border border-dashed border-blue-500/50 bg-blue-900/20 text-blue-400 hover:bg-blue-900/30 hover:text-blue-300 transition-colors flex flex-col items-center justify-center" data-id="element-4437" data-mp="1cf0ej1t6e0ki">
            <PlusIcon size={24} className="mb-2" data-id="element-4438" data-mp="36tks6uj2wvue" />
            <span data-id="element-4439" data-mp="3ecu52xqsnco7">Add Another Pivot</span>
          </button>
        </div>}

      {/* Total section */}
      <div className="flex justify-end" data-id="element-4440" data-mp="3javoxkw1ng0q">
        <div className="bg-slate-800/50 rounded-xl p-4 border border-blue-800/30 w-64" data-id="element-4441" data-mp="3j9kjlgmya07i">
          <div className="flex justify-between items-center text-blue-300 mb-2" data-id="element-4442" data-mp="3o2m1zymd8hvu">
            <span data-id="element-4443" data-mp="3t05fgwb8oqmq">Subtotal:</span>
            <span className="text-white" data-id="element-4444" data-mp="3t39qacj7mkmd">
              $
              {pivots.reduce((sum, pivot) => sum + (pivot.price || 0), 0).toFixed(2)}
            </span>
          </div>
          <div className="border-t border-blue-800/30 pt-2 mt-2" data-id="element-4445" data-mp="30dazocpdaffl">
            <div className="flex justify-between items-center" data-id="element-4446" data-mp="35b2yzrscd3tt">
              <span className="font-medium text-white" data-id="element-4447" data-mp="35dyy3jfxdyju">Total:</span>
              <span className="text-xl font-bold text-white" data-id="element-4448" data-mp="3aca8bva4ub2l">
                $
                {pivots.reduce((sum, pivot) => sum + (pivot.price || 0), 0).toFixed(2)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}